const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaEmbalagem: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PLANO_CARGA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PLANO_CARGA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'PLANO_CARGA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'PLANO_CARGA_EMBALAGEM_SELECT_LISTADO':
			return {
				...state,
				listaEmbalagem: action.payload.data
			};

        default:
            return state;
    }
}
